{
    "generic": "Something went wrong. Please try again.",
    "notFound": "We could not find what you were looking for."
}
